import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Col} from 'reactstrap';

const CreateOtpButtonComponent = (props) => {
  return (
    <Col className='otp-btn-container'>
      <div role='button' tabIndex='0' onClick={props.action} className='w-100 d-flex justify-content-center align-items-center'>
        <span className='align-middle'>
          <Image src={props.icon} alt={props.alt} />
        </span>
        <span
          className='align-middle text-center create-otp-button-description newPurple'
          dangerouslySetInnerHTML={{__html: props.description}}
        />
      </div>
    </Col>
  );
};
export default CreateOtpButtonComponent;
